import axiosInstance from '../../axiosInstance';

const getStreamByStreamKey = async stream_key => {
  const response = await axiosInstance(`/api/v2/streams/${stream_key}`);

  return response.data.data.stream;
};

export default getStreamByStreamKey;
